// extracted by mini-css-extract-plugin
module.exports = {"Container":"Logo_Container__1UXYa","Ring":"Logo_Ring__2QEqX","spin":"Logo_spin__2uDkY","Logo":"Logo_Logo__1N0xH"};